import { render, staticRenderFns } from "./formationStyle.vue?vue&type=template&id=6e668923&"
import script from "./formationStyle.vue?vue&type=script&lang=js&"
export * from "./formationStyle.vue?vue&type=script&lang=js&"
import style0 from "./formationStyle.vue?vue&type=style&index=0&id=6e668923&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports